/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import clone from 'clone';
import {
  Container,
  Grid,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
// actions
import { promptChangesMessage } from '../../../actions/prompt';
// import { fetchBobForms } from '../../../actions/bobForms';
// constants
import { DEFAULT_PROMPT } from '../../../constants/promptMessages';
import { namespaces } from '../../../constants/translation';
// components
import NavBar from '../../../components/NavBar';
// sections
import Info from './Info';
import Purchaser from './Purchaser';
import Payment from './Payment';
import Document from './Document';
import { OPPORTUNITY_STATUS } from '../../../constants/opportunityStatuses';// utils
import ActivityLog from './ActivityLog';
// utils
import { decodeSearch, encodeSearch } from '../../../utils/url';
import SectionTab from '../../../components/UpdatedComponents/UCSectionTab';
import OpportunityOverviewDetail from '../../../components/Opportunities/OpportunityOverviewDetail';
import Loan from './Loan';

class Overview extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          bookingHideLoanTracker: PropTypes.bool,
        }),
      }),
    }),
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      token: PropTypes.string,
    }),
    routeParamsID: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    bobForms: PropTypes.shape({
      data: PropTypes.array,
    }),
    templates: PropTypes.shape({
      data: PropTypes.shape({
        print: PropTypes.array,
      }),
    }),
    fetchNewBooking: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    checkHasChanges: PropTypes.func,
    token: PropTypes.string,
    loading: PropTypes.bool,
    paymentData: PropTypes.shape({
      id: PropTypes.string,
    }),
    documentData: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })),
    fetchBooking: PropTypes.func,
    fetchPaymentDetails: PropTypes.func,
    fetchDocument: PropTypes.func,
    onUpdateOpportunity: PropTypes.func,
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    bobForms: state.bobForms,
    templates: state.templates,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const query = decodeSearch(props.location.search);
    const isMobile = windowWidth < 768;
    const loading = props.loading;
    const data = { ...(props.data || {}) };
    const paymentData = props.paymentData;
    const documentData = props.documentData;
    let tabID = 1;
    if (!data.id && props.routeParamsID) {
      data.id = props.routeParamsID;
    }
    switch (query.section) {
      case 'info':
        tabID = 1;
        break;
      case 'purchaser':
        tabID = 2;
        break;
      case 'payment':
        tabID = 3;
        break;
      case 'loan':
        tabID = 4;
        break;
      case 'documents':
        tabID = 5;
        break;
      case 'logs':
        tabID = 6;
        break;
      default:
        tabID = 1;
        break;
    }
    // TODO: enable this when sr_source_of_finance is reliably populated
    // const isLoanTabLocked = !data.sr_source_of_finance || !data.sr_source_of_finance.toLowerCase().includes('loan');
    const PAYMENT_DOT_STATUSES = [
      OPPORTUNITY_STATUS.PAYMENT_MADE,
      OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED,
      OPPORTUNITY_STATUS.PAID_UNVERIFIED,
      OPPORTUNITY_STATUS.PAID_VERIFIED,
      OPPORTUNITY_STATUS.PENDING_REFUND,
      OPPORTUNITY_STATUS.PENDING_CANCELLATION,
      OPPORTUNITY_STATUS.VERIFICATION_REJECTED,
    ];
    const showPaymentDot = data && PAYMENT_DOT_STATUSES.includes(data.sr_status);
    const sectionTabs = [
      { id: 1, title: 'Info', description: 'Status, Pricing & Payment' },
      { id: 2, title: 'Purchaser', description: 'Details, E-Sign & Eligibility' },
      { id: 3, title: 'Payment', description: 'Payment', showDot: showPaymentDot },
      { id: 4, title: 'Loan', description: 'Loan' /* TODO: uncomment when enabling: , isLocked: isLoanTabLocked */ },
      { id: 5, title: 'Document', description: 'Document Sharing' },
      { id: 6, title: 'Activity Log', description: 'Activity Logs' },
    ];
    return {
      data,
      isMobile,
      loading,
      paymentData,
      documentData,
      oriData: clone(data),
      tabID,
      sectionTabs,
      refreshPage: false,
      docxPrintTemplates: [],
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      printTemplates: [],
      projectToken: '',
      systemData: [],
      isAutoReleaseTimerEnabled: false,
      isAgingARTimerEnabled: false,
      showShareEmailModal: false,
      project: [],
      allBankCases: [],
      hasDropCase: false,
      maUserAffiliateCompanyBranchName: '',
      docxPrintTemplates: [],
      isPrinting: false,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.data !== this.props.data ||
      prevProps.loading !== this.props.loading ||
      prevProps.paymentData !== this.props.paymentData ||
      prevProps.documentData !== this.props.documentData ||
      prevProps.location.search !== this.props.location.search
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(Overview.getPropsToState(this.props));
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
      this.setState({ ...state });
    }
  }
  handleTabChange = (tabData) => {
    if (!tabData || tabData.isLocked) {
      return;
    }
    const tabID = tabData.id;
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    let tab = 'info';
    const bookingId = this.state.data.id || this.props.routeParamsID;
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'payment';
        break;
      case 4:
        tab = 'loan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;

    this.setState({
      tabID: this.props.checkHasChanges() ? this.state.tabID : tabID,
    });
    if (tabData.page) {
      store.dispatch(push(`/opportunities/${bookingId}/${tabData.page}`));
    } else {
      const callback = () => {
        if (this.props.checkHasChanges()) {
          this.props.onCheck(false, () => this.setState({ tabID }));
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch(replace(`/opportunities/${bookingId}/?${encodeSearch(query)}`));
      };
      if (this.props.checkHasChanges()) {
        store.dispatch(promptChangesMessage({ message: DEFAULT_PROMPT, callback }));
      } else {
        callback();
      }
    }
  }
  render() {
    const {
      data,
      loading,
      documentData,
      isMobile,
      printTemplates,
      tabID,
      sectionTabs,
      maUserAffiliateCompanyBranchName,
      refreshPage,
      docxPrintTemplates,
    } = this.state;
    const paymentData = this.props.paymentData;
    const { t } = this.props;
    const combinedPrintTemplates = [...docxPrintTemplates, ...printTemplates];
    const combinedPrintTmplOnly = combinedPrintTemplates ? combinedPrintTemplates.filter(({ value }) => value !== 'customer_identities') : [];
    const sectionProps = { ...this.props, id: this.state.data.id || this.props.routeParamsID, token: this.props.token, mediaToken: this.props.token || (this.props.auth && this.props.auth.token), combinedPrintTmplOnly, isMobile, paymentData, documentData, loading, maUserAffiliateCompanyBranchName, refreshPage, opportunity: data };

    return (
      <Container>
        <NavBar
          header={t('Booking Overview')}
          // rightNav={this.checkAllowPrint(data && data) ? (
          //   <Menu.Item fitted>
          //     <div className="printButton">
          //     </div>
          //   </Menu.Item>
          // ) : null}
          bottomNode={
            <SectionTab
              loading={this.state.loading}
              isMobile={isMobile}
              isSticky
              onTabChange={this.handleTabChange}
              tabs={sectionTabs}
              tabID={tabID}
            />
          }
        />
        {data && data.id ? (
          <OpportunityOverviewDetail data={data} paymentData={this.props.paymentData} refundData={this.props.refundData} refundToken={this.props.refundToken} fetchRefunds={this.props.fetchRefunds} onUpdateOpportunity={this.props.onUpdateOpportunity} fetchBooking={this.props.fetchBooking} loading={this.state.loading} />
        ) : (
          <div className="ui placeholder segment">Loading or Accessing Data...</div>
        )}
        <Grid>
          <Grid.Column>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <SectionTab
                    loading={this.state.loading}
                    isMobile={isMobile}
                    onTabChange={this.handleTabChange}
                    tabs={sectionTabs}
                    tabID={tabID}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div className="uc-tab-page-spacer" />
            {tabID === 1 && <Info {...sectionProps} />}
            {tabID === 2 && <Purchaser {...sectionProps} />}
            {tabID === 3 && <Payment {...sectionProps} fetchBooking={this.props.fetchBooking} onUpdateOpportunity={this.props.onUpdateOpportunity} />}
            {tabID === 4 && (<Loan {...sectionProps} />)}
            {tabID === 5 && <Document {...sectionProps} />}
            {tabID === 6 && <ActivityLog {...sectionProps} />}
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Overview/Overview.jsx